import React from "react";
import ServicePage from "../ServicePage/Service.module.css";
import { NavLink } from "react-router-dom";
import aboutus from "../../../Assets/Banner/resoucesbanner.svg";
import { CiSearch } from "react-icons/ci";
import logo from "../../../Assets/Resources/Programming.png";

const Resource1 = () => {
  return (
    <div className={ServicePage.Services1_container}>
      <div className={ServicePage.Services1div1_container}>
        <h1 className={ServicePage.Services1text}>COMPANY RESOURCES</h1>
        <p className={ServicePage.text_container}>
          <ul>
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Home
              </NavLink>
            </li>
            <span>|</span>
            <li>
              <NavLink
                to="/resources"
                className={({ isActive }) => isActive && ServicePage.active}
              >
                Company Resources
              </NavLink>
            </li>
          </ul>
        </p>
      </div>
      <div className={ServicePage.Services1image_container}>
        <img src={aboutus} alt="image" className={ServicePage.Services1Img} />
      </div>
    </div>
  );
};

export default Resource1;
